export default __webpack_public_path__ + "static/media/capsule-landing-token-bnb.0ba988e8.png";